import { Controller } from '@hotwired/stimulus';
import { MDCSlider } from '@material/slider';

export default class extends Controller {
  connect() {
    this.slider = new MDCSlider(this.element);
  }

  disconnect() {
    if (this.slider) {
      this.slider.destroy();
    }
  }
}
